export const DECREMENT_CART_ITEM = "cartItem/decrement";
export const INCREMENT_CART_ITEM = "cartItem/increment";
export const ADD_SHOPPING_ITEM = "cartItem/add";
